import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressCircle from './../../../../ui/ProgressCircle/ProgressCircle';
import './DigitalReadinessQuiz.scss';

const questions = [
  {
    id: 'q1',
    question: 'Tem dados concretos sobre o perfil dos seus clientes?',
    type: 'radio',
    options: [
      'Não temos dados sobre isso',
      'Temos uma noção genérica',
      'Temos dados parciais, mas não atualizados',
      'Temos dados atualizados e utilizamo-los nas decisões',
    ],
  },
  {
    id: 'q2',
    question: 'A sua empresa recolhe feedback dos clientes de forma estruturada?',
    type: 'radio',
    options: [
      'Não',
      'De forma ocasional',
      'Temos um método informal (ex: redes sociais, conversas)',
      'Temos um sistema regular de recolha de análise de feedback',
    ],
  },
  {
    id: 'q3',
    question: 'A comunicação com os clientes é ajustada às suas preferências e canais preferidos?',
    type: 'radio',
    options: [
      'Comunicamos de forma generalista',
      'Tentamos adaptar, mas sem consistência',
      'Adaptamos parcialmente',
      'Sim, com base em dados e preferências reais dos clientes',
    ],
  },
  {
    id: 'q4',
    question: 'A sua empresa sabe por que motivo os clientes deixam de comprar ou mudam para a concorrência?',
    type: 'radio',
    options: [
      'Não sabemos',
      'Temos algumas suposições',
      'Investigamos pontualmente',
      'Monitorizamos e tomamos medidas com base nessa informação',
    ],
  },
  {
    id: 'q5',
    question: 'A sua empresa avalia regularmente se os seus produtos ou serviços estão alinhados com o que os clientes realmente valorizam?',
    type: 'radio',
    options: [
      'Não fazemos essa análise',
      'Pensamos nisso de forma intuitiva',
      'Avaliamos com base em feedback esporádico',
      'Sim, fazemos esse alinhamento com base em dados e ajustamos sempre que necessário',
    ],
  },
  {
    id: 'q6',
    question: 'Tem identificado o que distingue o seu negócio da concorrência?',
    type: 'radio',
    options: [
      'Não',
      'Achamos que sim, mas não está claro',
      'Temos uma proposta de valor, mas não a usamos estrategicamente',
      'Sim, temos uma proposta clara e exploramo-la ativamente',
    ],
  },
  {
    id: 'q7',
    question: 'Revê regularmente os processos internos para aumentar eficiência?',
    type: 'radio',
    options: [
      'Nunca',
      'Só quando surgem problemas',
      'De forma pontual',
      'Sim, como parte da gestão estratégica',
    ],
  },
  {
    id: 'q8',
    question: 'Avalia oportunidades de melhorar ou inovar na sua oferta?',
    type: 'radio',
    options: [
      'Não fazemos isso',
      'De forma informal',
      'Avaliamos algumas oportunidades',
      'Faz parte da nossa rotina estratégica',
    ],
  },
  {
    id: 'q9',
    question: 'Existe um plano digital definido?',
    type: 'radio',
    options: [
      'Não temos',
      'Estamos a pensar nisso',
      'Temos algo definido, mas pouco claro',
      'Sim, temos um plano com metas e acompanhamento',
    ],
  },
  {
    id: 'q10',
    question: 'Sabe quais canais digitais trazem mais retorno?',
    type: 'radio',
    options: [
      'Não sabemos',
      'Temos algumas pistas',
      'Sabemos parcialmente',
      'Sim, monitorizamos e investimos com base nesses dados',
    ],
  },
  {
    id: 'q11',
    question: 'A sua presença digital (website, redes sociais, plataformas) transmite de forma clara os valores e diferenciação do seu negócio?',
    type: 'radio',
    options: [
      'Não temos presença digital ou está desatualizada',
      'Temos presença, mas pouco trabalhada',
      'Tentamos comunicar esses aspetos, mas sem consistência',
      'sim, está alinhada com a identidade e estratégia da empresa',
    ],
  },
  {
    id: 'q12',
    question: 'Sabe se o que faz no digital está a gerar resultados concretos?',
    type: 'radio',
    options: [
      'Não',
      'Só analisamos números base (i.e. gostos, visitas)',
      'Analisamos vendas e métricas de conversão',
      'Sim, cruzamos dados de marketing, vendas e retorno financeiro',
    ],
  }
];

const correctAnswers = {
  q1: 'Temos dados atualizados e utilizamo-los nas decisões',
  q2: 'Temos um sistema regular de recolha de análise de feedback',
  q3: 'Sim, com base em dados e preferências reais dos clientes',
  q4: 'Monitorizamos e tomamos medidas com base nessa informação',
  q5: 'Sim, fazemos esse alinhamento com base em dados e ajustamos sempre que necessário',
  q6: 'Sim, temos uma proposta clara e exploramo-la ativamente',
  q7: 'Sim, como parte da gestão estratégica',
  q8: 'Faz parte da nossa rotina estratégica',
  q9: 'Sim, temos um plano com metas e acompanhamento',
  q10: 'Sim, monitorizamos e investimos com base nesses dados',
  q11: 'sim, está alinhada com a identidade e estratégia da empresa',
  q12: 'Sim, cruzamos dados de marketing, vendas e retorno financeiro',
};

const getResultMessage = (score) => {
  if (score <= 2) {
    return {
      title: 'A sua empresa é uma semente a germinar',
      imageUrl: '/images/quizpage/germinating-plant.webp',
      description:
        'Está a dar os primeiros passos no caminho digital. Ainda há muito por crescer, mas isso representa uma enorme oportunidade. Com pequenas mudanças orientadas, a sua empresa pode criar raízes sólidas, ganhar clareza e preparar-se para um crescimento sustentável.',
    };
  } else if (score <= 5) {
    return {
      title: 'A sua empresa já tem ramos, mas falta estrutura',
      imageUrl: '/images/quizpage/young-plant.webp',
      description:
        'A sua empresa já começou a crescer e tem alguns galhos promissores - mas ainda sem uma copa consistente. Falta um tronco forte e uma visão integrada. Com um plano bem definido, poderá fortalecer a estrutura e transformar o esforço atual em frutos consistentes.',
    };
  } else if (score <= 8) {
    return {
      title: 'Uma árvore em crescimento saudável',
      imageUrl: '/images/quizpage/young-tree.webp',
      description:
        'A sua empresa está num bom caminho, com um tronco firme e ramos bem posicionados. Já existem sinais de pensamento estratégico e práticas digitais maduras. Com apoio certo, pode acelerar o crescimento, fortalecer raízes e ampliar a copa com confiança.',
    };
  } else {
    return {
      title: 'Uma árvore robusta, cheia de frutos',
      imageUrl: '/images/quizpage/grown-tree.webp',
      description:
        'Parabéns! A sua empresa já tem raízes profundas e uma copa madura. Está a colher os frutos do esforço digital. Agora é o momento de escalar com inteligência, manter a vitalidade e garantir que cada fruto traga retorno e vantagem competitiva.',
    };
  }
};

const DigitalReadinessQuiz = () => {
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const handleChange = (questionId, value) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }));
  };

  const handleNext = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
    } else {
      let score = 0;
      for (const key in correctAnswers) {
        if (answers[key] === correctAnswers[key]) {
          score++;
        }
      }
      setSubmitted(score);
      console.log('User answers:', answers);
    }
  };

  const handleBack = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(prev => prev - 1);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleNext();
  };

  const navigate = useNavigate();
    
  const handleClick = () => {
    navigate('/', { state: { scrollToContact: true } });
  };


  if (typeof submitted === 'number') {
    const result = getResultMessage(submitted);
    return (
      <>
        <section className="dr__results section">
          <div className="wrapper wrapper--large centered">
            <div className='row'>
              <div className='col_img'>
                <img alt="" src={result.imageUrl} />
              </div>
              <div className='col_txt'>
                <h2 className="wrapper__title centered h1">{result.title}</h2>
                <div className="wrapper__subtitle h4 centered">{result.description}</div>
              </div>
            </div>
              
          </div>
        </section>

        <section className="dr__banner section">
          <div className="wrapper wrapper--small centered">
              <h3 className="wrapper__title centered h3">Próximo passo?</h3>
              <div className="wrapper__subtitle h5 centered">Quer saber o que estes resultados dizem sobre o futuro do seu negócio? Marque uma reunião gratuita com a Plover e receba:</div>
              <ul className='dr__banner--list'>
                <li>✔ Um breve relatório interpretado por especialistas</li>
                <li>✔ Dicas práticas para evoluir sem complicações</li>
                <li>✔ Um plano de ação adaptado à sua realidade</li>
              </ul>
              <button type="button" onClick={handleClick} className="cta-filled centered">Agendar reunião gratuita</button>
          </div>
        </section>
      </>
    );
  }

  const currentQuestion = questions[currentQuestionIndex];
  const hasAnswer = answers[currentQuestion.id];

  return (
    <section className="dr section">
      <div className="wrapper wrapper--medium">
      <h1 className="wrapper__title h2 centered">Qual o Nível de Maturidade Digital da sua Empresa?</h1>
        <div className='row reversed'>
          <div className='col'>
            <form className="dr-form" onSubmit={handleSubmit}>
              <fieldset key={currentQuestion.id} className="dr__question">
                <legend className="wrapper__subtitle h4">{currentQuestion.question}</legend>
                {currentQuestion.options.map((option, idx) => {
                  const inputId = `${currentQuestion.id}-${idx}`;
                  return (
                    <div key={inputId} className="dr__question--option">
                      <input
                        type="radio"
                        className="radio"
                        id={inputId}
                        name={currentQuestion.id}
                        value={option}
                        onChange={() => handleChange(currentQuestion.id, option)}
                        checked={answers[currentQuestion.id] === option}
                      />
                      <label htmlFor={inputId} className="dr__question--label">{option}</label>
                    </div>
                  );
                })}
              </fieldset>

              <div className="dr__nav">
                {currentQuestionIndex > 0 && (
                  <button
                    type="button"
                    className="cta-outlined"
                    onClick={handleBack}
                  >
                    Voltar
                  </button>
                )}
                <button
                  type="submit"
                  className="cta-filled"
                  disabled={!hasAnswer}
                >
                  {currentQuestionIndex === questions.length - 1
                    ? 'Ver resultado'
                    : 'Próximo'}
                </button>
              </div>
            </form>
          </div>
          <div className='col dr__sidebar'>
              <h4 className="centered">Progresso</h4>
              <ProgressCircle percentage={Math.round((currentQuestionIndex / questions.length) * 100)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalReadinessQuiz;